import axios from 'axios'
import { isValidCarrierMcDigits } from '@numeo/types-core'
import { CarrierSuggestion } from './types'

export interface McConflict {
    applicationId: string
    projectName: string
    companyName: string | null
}

export interface CarrierLookupResult {
    suggestions: CarrierSuggestion[]
    mcConflict: McConflict | null
}

/**
 * Search carrier by MC number using backend FMCSA API
 * Returns carrier suggestions and any in-org duplicate-MC conflict
 */
export const searchCarrierByMc = async (mcNumber: string): Promise<CarrierLookupResult> => {
    // Clean the MC number (remove non-digits)
    const cleanMc = mcNumber.replace(/\D/g, '')
    if (!isValidCarrierMcDigits(cleanMc)) {
        return { suggestions: [], mcConflict: null }
    }

    try {
        const response = await axios.get<{ success: boolean; data: CarrierSuggestion[]; mcConflict: McConflict | null }>(
            `/application/fmcsa/carrier/mc/${cleanMc}`
        )

        if (!response.data.success) {
            return { suggestions: [], mcConflict: null }
        }

        return { suggestions: response.data.data || [], mcConflict: response.data.mcConflict ?? null }
    } catch (error) {
        console.error('Failed to search carrier by MC:', error)
        return { suggestions: [], mcConflict: null }
    }
}

const fmcsaApi = {
    searchCarrierByMc,
}

export default fmcsaApi
